"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityStatuses = {
    scheduled: 1,
    sold: 2,
    closed: 3,
    open: 4
};
